import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-features-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './features-page.component.html',
  styleUrl: './features-page.component.css'
})
export class FeaturesPageComponent {

}
